module.exports = __webpack_public_path__ + "assets/images/iphone6-min.png";